// Shared taxonomy for sectioned PDF documents.
// Mirrors backend DOC_TAXONOMY in server.py.
export const DOC_TAXONOMY = {
  financial: {
    label: "Financial Statements",
    path: "/investor-relations/financial-statements",
    categories: [
      { slug: "annual-reports", label: "Annual Reports" },
      { slug: "annual-returns", label: "Annual Returns" },
    ],
  },
  shareholder: {
    label: "Shareholder Information",
    path: "/investor-relations/shareholder-information",
    categories: [
      { slug: "annual-report", label: "Annual Report" },
      { slug: "notice-board-meetings", label: "Notice of Board Meetings" },
      { slug: "policies", label: "Policies" },
      { slug: "code-of-conduct", label: "Code of Conduct" },
      { slug: "shareholding-structure", label: "Shareholding Structure" },
      { slug: "dematerialization", label: "Dematerialization" },
      { slug: "investor-complaints", label: "Redressal to Investor Complaints" },
      { slug: "merger-complaints", label: "Merger Documents" },
    ],
  },
};

export const SECTIONS = Object.keys(DOC_TAXONOMY);

export function categoryLabel(section, slug) {
  const sec = DOC_TAXONOMY[section];
  if (!sec) return slug;
  return sec.categories.find((c) => c.slug === slug)?.label || slug;
}
